import React, { FC, ReactNode } from 'react'
import { Box, Stack, Typography } from '@mui/material'

import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'

// Notion 流 設定 row. 左 = label (14/500) + description (12/400/secondary), 右 = control.
// py: 1.5, hairline border-bottom, 最後の row は consecutive を caller で管理.
interface SettingRowProps {
  label: ReactNode
  description?: ReactNode
  /** 右側の control (= Switch / Select / Button 等). */
  control: ReactNode
  /** divider を強制的に消す (= 最後の row や caller 都合). */
  noDivider?: boolean
}

export const SettingRow: FC<SettingRowProps> = ({
  label,
  description,
  control,
  noDivider,
}) => (
  <Stack
    direction="row"
    alignItems="flex-start"
    justifyContent="space-between"
    gap={2}
    sx={{
      py: 1.5,
      borderBottom: noDivider
        ? 'none'
        : `1px solid ${colorTokens.border.faint}`,
      '&:last-of-type': { borderBottom: 'none' },
    }}
  >
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 500,
          color: 'text.primary',
        }}
      >
        {label}
      </Typography>
      {description && (
        <Typography
          sx={{
            fontSize: 12,
            color: 'text.secondary',
            lineHeight: 1.6,
            mt: 0.25,
            whiteSpace: 'pre-line',
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
    <Box sx={{ flexShrink: 0 }}>{control}</Box>
  </Stack>
)
